// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__VsVHO","questions":"styles_questions__2tNFM","footer":"styles_footer__2pxXE"};